module.exports = __webpack_public_path__ + "static/team-15-940c818ebd18948cab31bd291cf4633c.jpg";